/**
 * Build UTF-8 JSON string for inverted pairing QR (v1).
 * @param {{ v: number, code: string, sessionId: string }} params
 */
export function buildQrPayload({ v, code, sessionId }) {
  return JSON.stringify({ v, code, sessionId });
}
